import { render, staticRenderFns } from "./corp-docs.vue?vue&type=template&id=b202f430"
import script from "./corp-docs.vue?vue&type=script&lang=js"
export * from "./corp-docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports